/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
// import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
// import InputLabel from '@material-ui/core/InputLabel';
import Alert from '@material-ui/lab/Alert';
import FormHelperText from '@material-ui/core/FormHelperText';
import useStyles from '../style';

const RequestReports = (props) => {
  const classes = useStyles();
  const {
    handleChange, isNewReport, reportData, handleRadioButton, reportListData, submitForm, resetForm,
    isRRSending, rRError, message, handleMessage, fieldsError, handleBlur, handleSearch, handleSearchClose,
  } = props;
  const {
    reportType, reportName, description, name, email,
  } = reportData;
  const {
    reportNameField, descriptionField, emailField, nameField,
  } = fieldsError;
  // const getOptions = () => {
  //   const options = reportListData.map((value) => <MenuItem key={`rq-${value.Name}`} value={value.Name}>{value.Name}</MenuItem>);
  //   return options;
  // };

  return (
    <Grid container>
      <Grid item md={8} sm={12} xs={12}>
        {message && (
          <Alert
            action={
              <Button color="inherit" size="small" onClick={() => handleMessage()}> X</Button>
              }
            variant="filled"
            severity={rRError ? 'error' : 'success'}
          >
            {message}
          </Alert>
        )}
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <h2 className={classes.requestReportHead}>Request Report</h2>
      </Grid>
      <Grid item md={12} sm={10} xs={10}>
        <div className={classes.requestReport}>
          <form className={classes.root} noValidate autoComplete="off" onSubmit={(event) => submitForm(event)}>
            <FormControl className={classes.formControl}>
              <Grid item md={3} sm={12} xs={12}>
                <RadioGroup className={classes.radioGroup} aria-label="requestReport" name="reportType" value={reportType} onChange={(event) => handleRadioButton(event)}>
                  <FormControlLabel value="Existing Report" control={<Radio classes={{ root: classes.radioButton, checked: classes.checked }} />} label="Existing Report" />
                  <FormControlLabel value="New Report" control={<Radio classes={{ root: classes.radioButton, checked: classes.checked }} />} label="New Report" />
                </RadioGroup>
              </Grid>
              { !isNewReport && (
                <Grid item md={6} sm={12} xs={12}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Autocomplete
                      value={reportName}
                      onChange={(event, newValue) => handleSearch(event, newValue)}
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      id="free-solo-with-text-demo"
                      options={reportListData}
                      getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === 'string') {
                          return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                          return option.inputValue;
                        }
                        // Regular option
                        return option.Name;
                      }}
                      renderOption={(option) => option.Name}
                      freeSolo
                      renderInput={(params) => (
                        <TextField
                          // eslint-disable-next-line react/jsx-props-no-spreading
                          {...params}
                          label="Report Name"
                          required
                          error={reportNameField}
                          name="reportName"
                          variant="outlined"
                        />
                      )}
                      onClose={(event) => handleSearchClose(event)}
                    />
                    {reportNameField && <FormHelperText className={classes.helperText}>This field is required</FormHelperText>}
                  </FormControl>
                </Grid>
              )}
              { isNewReport && (
                <Grid item md={6} sm={12} xs={12}>
                  <TextField
                    name="reportName"
                    id="newReport"
                    label="New Report Name"
                    className={classes.newReportName}
                    value={reportName}
                    onChange={(event) => handleChange(event)}
                    onBlur={(event) => handleBlur(event)}
                    variant="outlined"
                    required
                    error={reportNameField}
                    helperText={reportNameField ? 'This field is required' : ''}
                  />
                </Grid>
              )}
              <Grid item md={6} sm={12} xs={12}>
                <TextField
                  name="name"
                  id="name"
                  label="Name"
                  className={classes.newReportName}
                  value={name}
                  onChange={(event) => handleChange(event)}
                  onBlur={(event) => handleBlur(event)}
                  variant="outlined"
                  required
                  error={nameField}
                  helperText={nameField ? 'This field is required' : ''}
                  // inputProps={{
                  //   pattern: '^[a-zA-Z ]+$',
                  // }}
                />
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <TextField
                  name="email"
                  id="email"
                  label="Email"
                  className={classes.newReportName}
                  value={email}
                  onChange={(event) => handleChange(event)}
                  onBlur={(event) => handleBlur(event)}
                  variant="outlined"
                  required
                  error={emailField}
                  helperText={emailField ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <TextField
                  name="description"
                  id="description"
                  label="Description"
                  multiline
                  rows={4}
                  className={classes.description}
                  value={description}
                  onChange={(event) => handleChange(event)}
                  onBlur={(event) => handleBlur(event)}
                  variant="outlined"
                  required
                  error={descriptionField}
                  helperText={descriptionField ? 'This field is required' : ''}
                  inputProps={{ maxLength: 3000 }}
                />
              </Grid>
              <Grid item md={6} sm={12} xs={12} className={classes.formButtons}>
                <Button
                  disabled={isRRSending}
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classes.submitButton}
                >
                  {isRRSending ? 'Submitting...' : 'Submit'}
                </Button>
                <Button disabled={isRRSending} variant="contained" type="button" onClick={() => resetForm()}> Reset</Button>
              </Grid>
            </FormControl>
          </form>
        </div>
      </Grid>
    </Grid>
  );
};

/** Required function and props with the proptypes */
RequestReports.propTypes = {
  reportListData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  handleChange: PropTypes.func.isRequired,
  isNewReport: PropTypes.bool.isRequired,
  reportData: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  handleRadioButton: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  isRRSending: PropTypes.bool.isRequired,
  rRError: PropTypes.bool.isRequired,
  message: PropTypes.string,
  handleMessage: PropTypes.func.isRequired,
  fieldsError: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  handleBlur: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleSearchClose: PropTypes.func.isRequired,
};

export default RequestReports;
